export default __webpack_public_path__ + "static/media/coreEx_concat.ac1403f4.mp3";